var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"error-modal","centered":"","ok-only":"","header-bg-variant":"danger","title":"Error"}},[_c('p',{staticClass:"my-4"},[_c('span',{staticStyle:{"word-wrap":"break-word"}},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }